import { useAlertConfig } from './useAlertConfig';
export function useAlertsUrl(url) {
    var _a, _b;
    const { customUrls } = (_a = useAlertConfig()) !== null && _a !== void 0 ? _a : {};
    return (_b = customUrls === null || customUrls === void 0 ? void 0 : customUrls[url]) !== null && _b !== void 0 ? _b : '/notifications/' + url;
}
